import React from "react";
import { useTranslation } from "react-i18next";

import Burc from "../Components/urunlerimiz/Burc";
import PageHeader from "../Components/common/PageHeader";
import TopBar from "../Components/common/TopBar";
import Spacer4 from "../Components/common/Spacer4";
import useSEO from "../seo/useSEO";

function BurcPage() {
  const { t } = useTranslation();

  useSEO({
    title: "Özel Üretim Burç İmalatı | Aypin Otomat",
    description:
      "Aypin Otomat özel üretim burç çözümleri ve CNC kayar otomat ile hassas talaşlı imalat hizmetleri hakkında bilgi alın.",
    path: "/burc",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Ürünlerimiz",
        path: "/urunlerimiz",
      },
      {
        name: "Özel Üretim Burçlar",
        path: "/burc",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer4 />

      <PageHeader
        title={t("Özel Üretim Burçlar")}
      />

      <Burc />
    </>
  );
}

export default BurcPage;